import { render, staticRenderFns } from "./BrowserNotSupported.vue?vue&type=template&id=490e7bc4&scoped=true"
import script from "./BrowserNotSupported.vue?vue&type=script&lang=js"
export * from "./BrowserNotSupported.vue?vue&type=script&lang=js"
import style0 from "./BrowserNotSupported.vue?vue&type=style&index=0&id=490e7bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e7bc4",
  null
  
)

export default component.exports